<template>
    <div>
        <b-modal id="POIUploadModal" size="md" content-class="menu-bg-blue-transparent-modal" title="POI Upload" hide-footer
            hide-header-close scrollable @hide="clear">
            <b-container>
                <b-row class="brow-flex">
                    <b-col cols="3">
                        <label class="label-align">POI Name</label>
                    </b-col>
                    <b-col cols="9">
                        <b-form-input type="text" name="name" v-model="poi_name" placeholder="POI Name"
                            class="form-control poi-upload-formcontrol" />
                    </b-col>
                </b-row>
                <b-row class="brow-flex mt-2">
                    <b-col cols="6">
                        <label>Attach File (.csv)</label>
                    </b-col>
                    <b-col cols="6">
                        <a href="#" @click.prevent="generateSample" class="small text-primary" style="margin-left: 3px;">(Download Sample Template)</a>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <input 
                          type="file" 
                          name="file" 
                          id="poiFile" 
                          multiple="false" 
                          accept=".csv"
                          @change="handleFileUpload" 
                        />
                    </b-col>
                </b-row>
                <b-row v-if="loading" class="mt-4"
                    style="display: flex; justify-content: center; align-items: center; flex-direction: row; gap: 2%;">
                    <!-- Loading Spinner -->
                    <div class="d-flex justify-content-center py-1" v-if="!done">
                        <span class="highlightLoader p-1 spinner-border-md mr-2 mt-1">Uploading File...</span>
                        <span class="spinner-border spinner-border-md highlightLoader" role="status"
                            aria-hidden="true"></span>
                    </div>
                    <!-- <div class="green" v-else>
                        <span>File Upload Successful</span>
                        <fa :icon="['fas', 'check']" />
                    </div> -->
                </b-row>
                <b-row style="display: flex; justify-content: center; align-items: center;" class="mt-4" v-else>
                    <b-button @click="uploadFile" variant="primary">Upload File</b-button>
                </b-row>
            </b-container>
        </b-modal>
    </div>
</template>
<style>
.poi-upload-formcontrol {
    margin-bottom: 10px;
}

.brow-flex {
    display: flex;
    justify-content: space-around;
}

.label-align {
    margin-top: 8%;
}    
</style>

<script>
import axios from 'axios'
import * as XLSX from 'xlsx'
export default {
    name: 'MMP_Analytics_Upload',
    props: ['user', 'wclLayersButtonsCtrl', 'selectedExtent', 'extentResponse'],
    data() {
        return {
            poi_name: null,
            loading: false,
            progress: 0,
            fileContent: null,
            file: null,
            done: false,
            poiRegionList: ['NA', 'EU', 'JP', 'ME'],
            poiRegion: null,
            isRegionError: false,
        }
    },
    methods: {
        generateSample() {
            try {
                // Define headers and one row of sample data
                const headers = ['Name', 'Address', 'LAT', 'LON'];
                const sampleRow = ['TEXT', 'TEXT', 'NUMBER', 'NUMBER'];

                // Create a sheet using XLSX.utils.aoa_to_sheet (Array of Arrays)
                const sheet = XLSX.utils.aoa_to_sheet([headers, sampleRow]);

                // Convert the sheet to CSV
                const csvContent = XLSX.utils.sheet_to_csv(sheet);

                // Create a link and trigger it to download the CSV
                const link = document.createElement('a');
                link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent);
                link.download = 'POI_Template.csv'; // The filename for download
                link.click();
            } catch (error) {
                console.error(error);
            } 
        },
        clear() {
            this.poiRegion = null;
            this.poi_name = null;
            this.file = null;
            this.fileContent = null;
        },
        openPOIModal() {
            this.$bvModal.show('POIUploadModal')
        },
        handleFileUpload(e) {
            this.file = e.target.files[0]
        },
        async uploadFile() {
            if (this.poi_name == null || this.poi_name == '') {
                this.$bvToast.toast('No POI Name Inputted', {
                    autoHideDelay: 100000,
                    variant: 'danger',
                    solid: true,
                    title: 'Input Error',
                    toaster: 'b-toaster-top-right'
                })
                return;
            }

            if (this.file == null) {
                this.$bvToast.toast('No file chosen', {
                    autoHideDelay: 100000,
                    variant: 'danger',
                    solid: true,
                    title: 'Upload Failed',
                    toaster: 'b-toaster-top-right'
                })
                return;
            }

            let extent_id = this.extentResponse.find((layer) => layer.extent_description == this.selectedExtent).id

            this.done = false
            this.loading = true
            const formData = new FormData()
            formData.append("csvFile", this.file)
            if (sessionStorage.token) {
                //await this.clearLayerCache()
                axios.post(process.env.API_LOCATION + '/api/analytics/upload_file', formData, {
                    headers: {
                        'x-auth-token': sessionStorage.token,
                    },
                    params: {
                        poiType: this.poi_name,
                        poiRegion: this.selectedExtent,
                        user: this.user.name,
                        extent_id: extent_id
                    }
                })
                    .then(response => {
                        const content = response.data
                        if (content.error) {
                            console.log('upload_file API CALL ERROR: ' + content.error)
                            this.$bvToast.toast('Failed to Upload File', {
                                autoHideDelay: 10000,
                                variant: 'danger',
                                solid: true,
                                title: 'Upload Status',
                                toaster: 'b-toaster-top-right'
                            })
                        }
                        // Find POI Uploads Layer and set it to visible
                        const poiLayer = this.wclLayersButtonsCtrl.find(layer => layer.name == 'POI Uploads')
                        if (poiLayer) {
                            poiLayer.display_name = this.poi_name
                            poiLayer.poi = true
                        }
                        this.$bvToast.toast('File Upload Successful.', {
                            autoHideDelay: 500,
                            variant: 'success',
                            solid: true,
                            title: 'Successful',
                            toaster: 'b-toaster-top-right'
                        })
                        this.done = true
                        setTimeout(() => {
                            this.loading = false
                            this.done = false
                            this.clear();
                            this.$emit('refresh')
                            this.$bvModal.hide('POIUploadModal')
                        }, 2000)
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            } else {
                console.log('No User Token')
                this.$router.push({ name: 'Login' })
            }
        }
    },
    
};
</script>

<style>
.upload-btn {
    height: 30px;
    width: 30px;
    border-radius: 5px;
    background: rgb(21, 140, 87, 0.8);
    border: 1px solid rgb(21, 140, 87, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: font-size 0.5s ease, color 0.5s ease, height 0.5s ease, width 0.5s ease, border-radius 0.5s ease;
    font-size: 20px;
    color: white;
    cursor: pointer;
}

.upload-btn:hover {
    opacity: 0.8
}

/* 
.green {
    color: green;
} */
</style>